<template>
    <div class="user-picker" v-loading="!ready || loading" :class="{ 'user-picker-selectable': selectable }">
        <template v-if="ready">
            <kendo-datasource
				ref="gridDataSource"
				:page-size="10"
				:schema="gridDataSource.schema"
				:server-paging="true"
				:server-sorting="true"
				:server-filtering="true"
				:transport-read="gridDataSource.transport.read"
			/>
			<kendo-grid
				ref="grid"
				:column-menu="false"
				:column-resize-handle-width="8"
				:data-source-ref="'gridDataSource'"
				:filterable="grid.filterable"
				:groupable="grid.groupable"
				:pageable="grid.pageable"
				:resizable="false"
				:selectable="selectable"
				:sortable="true"
                @change="onGridChange"
                @databound="onGridChange"
			>
				<kendo-grid-column
                    v-if="!selectable"
					:command="[
						{
							name: 'Add', 
							click: onAdd,
							iconClass: 'k-icon k-i-add',
							text: ' '
						}
					]" 
					width="56px"
				/>
				<kendo-grid-column 
					field="userName" 
					title="User name" 
					width="226px" 
					:filterable-cell-show-operators="false" 
				/>
				<kendo-grid-column 
					field="firstName" 
					title="First name" 
					width="100px"
					:filterable-cell-show-operators="false" 
				/>
				<kendo-grid-column 
					field="lastName" 
					title="Last name" 
					width="100px"
					:filterable-cell-show-operators="false" 
				/>						
				<kendo-grid-column 
					field="emailAddress" 
					title="Email" 
					width="250px" 
					:filterable-cell-show-operators="false" 
				/>
                <kendo-grid-column
                    v-if="!displayingUnregisteredUsers"
                    field="lastLoginOn"
                    title="Last Logged In"
                    width="150px"
                    :filterable-cell-show-operators="false"
                    template="#= (lastLoginOn == null) ? '' : kendo.toString(lastLoginOn, 'MMMM dd, yyyy hh:mm tt') #"
                />
				<kendo-grid-column
                    v-if="displayingUnregisteredUsers"
					field="workAreaID" 
					title="Work area" 
					width="275px" 
					template="#=workAreaName#"
					:filterable-cell-template="workAreaFilter"
					:filterable-cell-show-operators="false" 
				/>
			</kendo-grid>
        </template>
	</div>
</template>


<script>
	import _ from 'lodash';
	import $ from 'jquery';
    import { AsyncMixin } from 'pdk/mixins';
    import { PropValidator } from 'pdk/util';
    import { KendoGridMixin } from '@/mixins';
	import { groups, users } from '@/services';


	export default {
		name: 'user-picker',
        mixins: [AsyncMixin, KendoGridMixin],
        props: {
            source: {
                type: String,
                required: false,
                default: 'unregistered',
                validator: PropValidator('source', ['registered', 'unregistered'])
            },
            locationGroupId: {
                type: String,
                default: null
            },
            selectable: {
                type: Boolean,
                default: false
            }
        },
		data() {
			return {
				grid: {
                    filterable: {
                        mode: 'row',
						extra: false
                    },
                    groupable: {
                        enabled: false,
                        showFooter: false
					},
					pageable: {
                        alwaysVisible: true,
                        refresh: true
                    }
                },
				workAreas: undefined
			};
        },
        computed: {
            ready() {
                if (this.displayingUnregisteredUsers) return this.workAreas && this.workAreas.length;

                return true;
            },
            displayingRegisteredUsers() {
                return this.source === 'registered';
            },
            displayingUnregisteredUsers() {
                return this.source === 'unregistered';
            },
            gridDataSource() {
                switch (this.source) {
                    case 'registered': return groups.getCandidates_KendoDataSource({
                        locationGroupID: this.locationGroupId
                    });
                    case 'unregistered': return users.getCandidates_KendoDataSource();
                    default: return undefined;
                }
            }
        },
        created() {
            if (this.displayingUnregisteredUsers) {
                this.async(users.getWorkAreas())
                    .then((workAreas) => {
                        this.workAreas = workAreas;
                    });
            }
		},
		methods: {
			workAreaFilter(e) {
                e.element.kendoDropDownList({
                    dataSource: this.workAreas,
                    valuePrimitive: true,
                    dataTextField: 'workAreaName',
                    dataValueField: 'workAreaID',
                    optionLabel: '- All work areas -'
                });
			},
			onAdd(e) {
                e.preventDefault();

                const helper = this.getKendoGridHelper('grid');
                var item = helper.getItem($(e.currentTarget).closest('tr'));

                this.$emit('change', item);
            },
            onGridChange() {
                if (!this.selectable) return;

                const helper = this.getKendoGridHelper('grid');
                const item = helper.getSelectedItems()[0];

                this.$emit('change', item);
            }
		}
	};
</script>


<style lang="scss">
@import '~@/assets/styles/references';

.user-picker {
    &:not(.user-picker-selectable) {
        .k-grid td:first-child { padding-left: gx(0.5); }
    }

    .k-command-cell {
        padding: 4px 8px;
        text-align: center;
        > .k-button {
            margin: 2px 0;
            min-width: 0;
            background: color(primary);
            color: color(white);
            padding: 4px 16px;
            height: 28px;
            min-height: 28px;

            @include hover { background-color: color(primary, hover); }
        }
    }

    .k-button {
        .k-icon {
	        margin: 0 auto;
        }
    }
}

</style>

